import ApplicationLoader from "@/containers";

import MeterContainer from "./MeterContainer";

const AppLoader = new ApplicationLoader(MeterContainer);

AppLoader.start();
